import { memo, useCallback } from 'react';
import Div from '../Div';
import Button from '../Button';
import { useProfileContext } from '@/context/profileContext';
import { useAppConfigContext } from '@/context/AppContext';
import Paragraph from '../Paragraph';
import classNames from 'classnames';
import { PDP_COUPON_MODAL_OPEN } from '@/constants/app';

const ExistingUser = (props: any) => {
  const { state: profile } = useProfileContext();
  const { dispatch: appConfigDispatch } = useAppConfigContext();
  const { flags } = props;

  const onLogin = () => {
    window.location.hash = PDP_COUPON_MODAL_OPEN;
  };
  const onClickHander = useCallback(() => {
    appConfigDispatch.toggleLoginModal('#', undefined, onLogin);
  }, []);

  return (
    <>
      {!profile?.isLoggedIn && props.title ? (
        <Div
          className={classNames(
            'w-full h-auto p-s5 bg-gradient-to-l from-white to-yellow-50 rounded-cm border border-amber-300 flex-col justify-start items-center inline-flex mt-s4',
            {
              'mt-s9 md:mt-s10': !flags?.prexoApplicable,
            },
          )}
        >
          <Div className="self-stretch justify-start items-center gap-2 inline-flex">
            <Div className="grow shrink basis-0 flex-col justify-start items-start gap-s2 inline-flex">
              <Paragraph className="text-h-4">{props.title}</Paragraph>
              <Paragraph className="text-body-base">{props.subTitle}</Paragraph>
            </Div>
            <Button
              theme="link"
              className="bg-[#E0B151] text-white !py-s3 !px-s4 rounded-cxs hover:no-underline"
              onClick={onClickHander}
            >
              {props.ctaLabel}
            </Button>
          </Div>
        </Div>
      ) : null}
    </>
  );
};

export default memo(ExistingUser);
